module.exports = __webpack_public_path__ + "static/Powerpants-f9ad9381025dceb556a19b162e8ff050.png";